import { StripeVerification,
  StripeVerificationService,
  User,
  UserVerificationService,
  Verification } from 'us-web-services';
import { action, makeObservable, observable } from 'mobx';
import { UserStore } from '../UserStore';

export class VerificationStore {
  stripeVerification?: StripeVerification;
  userVerification?: Verification;
  user?: User;
  isPolling: boolean = false;
  POLL_MS: number = 2500;
  callback?: () => void;
  interval?: NodeJS.Timeout;
  loadingStripe: boolean = false;
  loadingFacebook: boolean = false;

  constructor(userStore: UserStore) {
    this.user = userStore.user;
    makeObservable(this, {
      getStripeVerification: action,
      getUserVerification: action,
      stripeVerification: observable,
      userVerification: observable,
      loadingStripe: observable,
      loadingFacebook: observable,
    });
  }
  getStripeVerification = async (): Promise<void> => {
    const config = {
      params: {
        userId: this.user?.id,
      },
    };
    const response = (await StripeVerificationService.getByFilter(config)).data;
    this.stripeVerification = response.data?.pop();
    await this.getUserVerification();
    if (this.stripeComplete() || this.isVerified()) {
      this.loadingStripe = false;
    }

    if ((this.stripeComplete() || this.stripeFailed()) && this.interval) {
      clearInterval(this.interval);
      this.isPolling = false;
    }
  }

  getUserVerification = async (): Promise<void> => {
    if (!this.user?.id) return;
    const response = (await UserVerificationService.get(this.user.id)).data;
    this.userVerification = response?.data;
  }

  canStripeVerify = (): boolean => !!this.userVerification && !!this.userVerification.methods && !!this.userVerification.methods.stripe

  canFacebookVerify = (): boolean => !!this.userVerification && !!this.userVerification.methods && !!this.userVerification.methods.facebook

  stripeComplete = (): boolean => !!this.stripeVerification && this.stripeVerification?.status === 'success';
  stripeFailed = (): boolean => !!this.stripeVerification && this.stripeVerification?.status === 'fail';
  stripeProcessing = (): boolean => !!this.stripeVerification && this.stripeVerification?.status === 'processing';
  stripeRequiresInput = (): boolean => !!this.stripeVerification && this.stripeVerification?.status === 'requires_input';
  stripeInProgress = (): boolean => {
    const progressStatus = ['initial', 'processing', 'requires_input'];
    return !!this.stripeVerification && !!this.stripeVerification?.status && progressStatus.indexOf(this.stripeVerification.status) > -1;
  }

  isVerified = (): boolean => !!this.userVerification && this.userVerification?.passed === true

  isFailed = (): boolean => !this.canStripeVerify() && !this.canFacebookVerify() && !this.stripeProcessing();

  openStripe = (stripeAction: string): void => {
    this.loadingStripe = true;
    window.open(`/app/complete-identity-verification?action=${stripeAction}`);
    setTimeout(() => {
      this.loadingStripe = false;
    }, this.POLL_MS);
    if (!this.isPolling) {
      this.isPolling = true;
      this.interval = setInterval(this.getStripeVerification, this.POLL_MS);
    }
  }

  checkVerification = (callback: () => void, openModal: () => void): void => {
    if (this.userVerification?.passed) {
      callback();
    } else {
      this.callback = callback;
      openModal();
    }
  }
}
